import React, { useContext } from 'react';

import { ResearchContext } from '../../ResearchContext';


import {
    Grid,
    TextField
} from '@mui/material';
import { SearchType } from "../../../../../helpers";


export function LiberaFilter() {

    const {

        state,

        setTestoFilter,

        activeSearchType,

    } = useContext(ResearchContext);

    return activeSearchType == SearchType.Libera &&
        <Grid container>
            <Grid item xs={12} padding={1} >
                <TextField
                    fullWidth
                    label="Testo libero"
                    placeholder='Inserisci il testo libero'
                    onChange={(e) => setTestoFilter(e.target.value)}
                />
            </Grid>
        </Grid>
}